Namespace 'Monitoring.Reports.Publications'

class Monitoring.Reports.Publications.ContentView extends Backbone.View

  className: 'content-item delimiter'
  template: JST['backbone/templates/monitoring/reports/publications/content']

  initialize: (@options = {}, @header) ->
    # just set @options

  render_twitter: ->
    embedded_view = new Monitoring.Reports.Publications.Content.EmbeddedView(@options)
    details_view = new Monitoring.Reports.Publications.Content.DetailsView(@options)
    sentiment_view = new Monitoring.Reports.Publications.Content.SentimentView(@options, @header)
    @analytics = analytics_view = new Monitoring.Reports.Publications.Content.AnalyticsView(@options)
    notes_view = new Monitoring.Reports.Publications.Content.NotesView(@options)

    @sections_count = 4
    @sections_rendered = 0
    embedded_view.bind('rendered', @rendered).bind('fail', @fail)
    sentiment_view.bind('rendered', @rendered).bind('fail', @fail)
    analytics_view.bind('rendered', @rendered).bind('fail', @fail)
    notes_view.bind('rendered', @rendered).bind('fail', @fail)

    embedded_view.render()
    details_view.render()
    sentiment_view.render_twitter()
    analytics_view.render()
    notes_view.render()

    embedded_section = embedded_view.el
    analysis_section = $('<div/>').addClass('content-section content-analysis')

    details_subsection = details_view.el
    metrics_subsection = $('<div/>').addClass('content-section content-metrics')
    notes_subsection = notes_view.el
    analysis_section.append(details_subsection).append(metrics_subsection).append(notes_subsection)

    analytics_subsection = analytics_view.el
    sentiment_subsection = sentiment_view.el
    metrics_subsection.append(analytics_subsection).append(sentiment_subsection)

    @$el.append(embedded_section)
    @$el.append(analysis_section)

    content_id = @options.contents[0].content_id
    @$el.attr('id', content_id)


  render: ->

    has_targeting = @options.targeting

    embedded_view = new Monitoring.Reports.Publications.Content.EmbeddedView(@options)
    details_view = new Monitoring.Reports.Publications.Content.DetailsView(@options)
    targeting_view = new Monitoring.Reports.Publications.Content.TargetingView(@options)
    sentiment_view = new Monitoring.Reports.Publications.Content.SentimentView(@options, @header)
    @analytics = analytics_view = new Monitoring.Reports.Publications.Content.AnalyticsView(@options)
    notes_view = new Monitoring.Reports.Publications.Content.NotesView(@options)

    @sections_count = if has_targeting then 5 else 4
    @sections_rendered = 0
    targeting_view.bind('rendered', @rendered).bind('fail', @fail) if has_targeting
    embedded_view.bind('rendered', @rendered).bind('fail', @fail)
    sentiment_view.bind('rendered', @rendered).bind('fail', @fail)
    analytics_view.bind('rendered', @rendered).bind('fail', @fail)
    notes_view.bind('rendered', @rendered).bind('fail', @fail)

    embedded_view.render()
    details_view.render()
    targeting_view.render() if has_targeting
    sentiment_view.render()
    analytics_view.render()
    notes_view.render()

    embedded_section = embedded_view.el
    analysis_section = $('<div/>').addClass('content-section content-analysis')

    details_subsection = details_view.el
    metrics_subsection = $('<div/>').addClass('content-section content-metrics')
    targeting_subsection = targeting_view.el
    notes_subsection = notes_view.el
    analysis_section.append(details_subsection)
    analysis_section.append(metrics_subsection)
    analysis_section.append(targeting_subsection) if has_targeting
    analysis_section.append(notes_subsection)

    analytics_subsection = analytics_view.el
    sentiment_subsection = sentiment_view.el
    metrics_subsection.append(analytics_subsection).append(sentiment_subsection)

    @$el.append(embedded_section)
    @$el.append(analysis_section)

    content_id = @options.contents[0].content_id
    @$el.attr('id', content_id)

  rendered: =>
    @sections_rendered += 1
    @$('.spinner').remove() if @sections_rendered >= @sections_count

  fail: =>
    # TODO generic template (with summary_view)
    error_message = I18n.t("monitoring.dashboard.publications.error")
    @$('.spinner').replaceWith("<div class='error'><i class='fa fa-exclamation-triangle'></i> #{error_message}</div>")

  fill_analytics: (data) ->
    content_id = @options.contents[0].content_id
    content_data = data[content_id]
    @analytics.fill_analytics(content_data)

  fill_twitter_analytics:(data) ->
    content_id = @options.contents[0].content_id
    content_data = data[content_id]
    @analytics.fill_twitter_analytics(content_data)